import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// importing all the pages
import { Moon } from "../Pages/index";

class MyRouts extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/earthsmoon" component={Moon} />
        </Switch>
      </Router>
    );
  }
}
export default MyRouts;
